<template>
  <div class="multi-community-fee-summary-container">
    <!-- 搜索栏 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="community-select-wrapper">
            <el-select
              v-model="searchForm.communityIds"
              multiple
              collapse-tags
              :placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderCommunity')"
              class="w-100"
            >
              <el-option
                v-for="item in communityList"
                :key="item.communityId"
                :label="item.name"
                :value="item.communityId"
              />
            </el-select>
            <el-button
              size="mini"
              type="text"
              @click="toggleSelectAllCommunities"
              class="select-all-btn"
            >
              {{ isAllCommunitiesSelected ? '取消全选' : '全选' }}
            </el-button>
          </div>
        </el-col>
        <el-col :span="8">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            :range-separator="$t('communityFeeSummary.multiCommunityFeeSummary.search.rangeSeparator')"
            :start-placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderStartDate')"
            :end-placeholder="$t('communityFeeSummary.multiCommunityFeeSummary.search.placeholderEndDate')"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            class="w-100"
          />
        </el-col>
        <el-col :span="4" class="text-right">
          <el-button type="primary" @click="handleSearch">{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.search') }}</el-button>
          <el-button @click="handleReset">{{ $t('communityFeeSummary.multiCommunityFeeSummary.search.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- Tab 切换 -->
    <el-card class="box-card mt-20">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane
          :label="$t('communityFeeSummary.multiCommunityFeeSummary.tab.byCommunity')"
          name="byCommunity"
        >
          <!-- 按小区汇总表格 -->
          <el-table :data="summaryData" border style="width: 100%" v-loading="loading">
            <el-table-column
              prop="communityId"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.communityName')"
              align="center"
              min-width="140"
              fixed="left"
            >
              <template slot-scope="scope">
                {{ communityMap[scope.row.communityId] || scope.row.communityId }}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.totalRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="feeRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="oweRoomCount"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.oweRoomCount')"
              align="center"
              width="90"
            />
            <el-table-column
              prop="hisOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.hisOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.hisOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curReceivableFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curReceivableFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curReceivableFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curReceivedFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curReceivedFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curReceivedFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="curOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.curOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.curOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalOweFee"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.totalOweFee')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.totalOweFee) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="actualPaid"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.actualPaid')"
              align="right"
              width="130"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.actualPaid) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="feeRoomRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRoomRate')"
              align="center"
              width="110"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.feeRoomRate) }">
                  {{ formatRate(scope.row.feeRoomRate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="feeRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeRate')"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.feeRate) }">
                  {{ formatRate(scope.row.feeRate) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="clearRate"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.clearRate')"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span :style="{ color: getRateColor(scope.row.clearRate) }">
                  {{ formatRate(scope.row.clearRate) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="mt-10 text-right"
            @size-change="handleSummarySizeChange"
            @current-change="handleSummaryCurrentChange"
            :current-page="summaryPagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="summaryPagination.row"
            layout="total, sizes, prev, pager, next, jumper"
            :total="summaryPagination.total"
          />
          <div class="text-right mt-10">
            <el-button type="success" @click="handleExport">{{ $t('communityFeeSummary.multiCommunityFeeSummary.export') }}</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane
          :label="$t('communityFeeSummary.multiCommunityFeeSummary.tab.byDetail')"
          name="byDetail"
        >
          <!-- 按明细汇总表格 -->
          <el-table :data="detailData" border style="width: 100%" v-loading="loading">
            <el-table-column
              prop="communityId"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.communityName')"
              align="center"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ communityMap[scope.row.communityId] || scope.row.communityId }}
              </template>
            </el-table-column>
            <el-table-column
              prop="feeName"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.feeName')"
              align="center"
              min-width="120"
            />
            <el-table-column
              prop="detailYear"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.year')"
              align="center"
              width="80"
            />
            <el-table-column
              prop="detailMonth"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.month')"
              align="center"
              width="80"
            />
            <el-table-column
              prop="receivableAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.receivableAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.receivableAmountTotal) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="receivedAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.receivedAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.receivedAmountTotal) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="oweAmountTotal"
              :label="$t('communityFeeSummary.multiCommunityFeeSummary.table.oweAmountTotal')"
              align="right"
              min-width="140"
            >
              <template slot-scope="scope">
                {{ formatMoney(scope.row.oweAmountTotal) }}
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            class="mt-10 text-right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.row"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          />
          <div class="text-right mt-10">
            <el-button type="success" @click="handleExport">{{ $t('communityFeeSummary.multiCommunityFeeSummary.export') }}</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 指标说明 -->
    <el-card class="box-card mt-20">
      <el-collapse v-model="explainActive">
        <el-collapse-item name="explain">
          <template slot="title">
            <i class="el-icon-info explain-icon"></i>
            <span>{{ $t('communityFeeSummary.multiCommunityFeeSummary.indicatorExplanation') }}</span>
          </template>
          <el-table :data="explainIndicators" border size="mini">
            <el-table-column prop="name" :label="explainText.colIndicator" width="150" />
            <el-table-column prop="desc" :label="explainText.colDefinition" />
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </div>
</template>

<script>
import { queryReportCommunityFeeSummary, queryReportCommunityFeeSummaryDetail } from '@/api/report/multiCommunityFeeSummaryApi'
import { getMyEnteredCommunitys } from '@/api/community/communityApi'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'MultiCommunityFeeSummaryList',
  data() {
    return {
      activeTab: 'byCommunity',
      searchForm: {
        communityIds: [],
        dateRange: []
      },
      communityList: [],
      communityMap: {},
      isAllCommunitiesSelected: false,
      explainActive: ['explain'],
      summaryData: [],
      detailData: [],
      loading: false,
      summaryPagination: {
        page: 1,
        row: 20,
        total: 0
      },
      pagination: {
        page: 1,
        row: 20,
        total: 0
      }
    }
  },
  created() {
    this.loadCommunities()
  },
  watch: {
    'searchForm.communityIds'(val) {
      this.isAllCommunitiesSelected = this.communityList.length > 0 && val.length === this.communityList.length
    }
  },
  computed: {
    isZh() {
      return this.$i18n && this.$i18n.locale ? this.$i18n.locale.indexOf('zh') === 0 : true
    },
    explainText() {
      if (this.isZh) {
        return { colIndicator: '指标', colDefinition: '定义' }
      }
      return { colIndicator: 'Indicator', colDefinition: 'Definition' }
    },
    explainIndicators() {
      if (this.isZh) {
        return [
          { name: '总户数', desc: '该小区在用房屋总数（含商铺、车位等收费对象对应的房屋）' },
          { name: '收费户数', desc: '查询区间内存在费用账单（应收或实收）的房屋数' },
          { name: '欠费户数', desc: '应收金额大于实收金额的房屋数（含历史欠费）' },
          { name: '历史欠费', desc: '查询开始日期之前各月份尚未缴清的账单总额' },
          { name: '当期应收', desc: '查询区间内账单的应收总额（不管是否已收）' },
          { name: '当期实收', desc: '查询区间内账单中已实际收到的金额' },
          { name: '当期欠费', desc: '当期应收 − 当期实收，即查询区间内账单尚未收取的部分' },
          { name: '总欠费', desc: '历史欠费 + 当期欠费，截至查询结束日期的全部未收金额' },
          { name: '实缴', desc: '查询区间内实际收到的金额（= 当期实收）' },
          { name: '户收费率', desc: '(收费户数 − 欠费户数) ÷ 收费户数 × 100%，已缴清户数占比' },
          { name: '收费率', desc: '当期实收 ÷ 当期应收 × 100%，当期账单收回比例' },
          { name: '清缴率', desc: '实缴 ÷ 总欠费 × 100%，欠费回收能力' },
          { name: '应收金额（明细Tab）', desc: '按小区 × 费用项 × 年月汇总的应收总额' },
          { name: '实收金额（明细Tab）', desc: '按小区 × 费用项 × 年月汇总的实收总额' },
          { name: '欠费金额（明细Tab）', desc: '应收金额 − 实收金额' }
        ]
      }
      return [
        { name: 'Total Rooms', desc: 'Total number of active rooms in the community' },
        { name: 'Charged Rooms', desc: 'Rooms with fee bills (receivable or received) within the query period' },
        { name: 'Owe Rooms', desc: 'Rooms where receivable amount exceeds received amount (including history arrears)' },
        { name: 'History Owe', desc: 'Unpaid bills for all months before the query start date' },
        { name: 'Current Receivable', desc: 'Full receivable amount of bills within the query period' },
        { name: 'Current Received', desc: 'Actually received amount of bills within the query period' },
        { name: 'Current Owe', desc: 'Current receivable − current received' },
        { name: 'Total Owe', desc: 'History owe + current owe, all unpaid as of the end date' },
        { name: 'Actual Paid', desc: 'Actually received within the query period (= current received)' },
        { name: 'Room Charge Rate', desc: '(Charged rooms − owe rooms) ÷ charged rooms × 100%' },
        { name: 'Fee Rate', desc: 'Current received ÷ current receivable × 100%' },
        { name: 'Clear Rate', desc: 'Actual paid ÷ total owe × 100%' },
        { name: 'Receivable (Detail Tab)', desc: 'Receivable total grouped by community × fee × year-month' },
        { name: 'Received (Detail Tab)', desc: 'Received total grouped by community × fee × year-month' },
        { name: 'Owe (Detail Tab)', desc: 'Receivable − received' }
      ]
    }
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getMyEnteredCommunitys({ page: 1, row: 500 })
        this.communityList = res.communitys || []
        this.communityMap = {}
        this.communityList.forEach(c => {
          this.$set(this.communityMap, c.communityId, c.name)
        })
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    buildParams() {
      const params = {
        communityIds: this.searchForm.communityIds ? this.searchForm.communityIds.join(',') : '',
        startDate: this.searchForm.dateRange ? this.searchForm.dateRange[0] : '',
        endDate: this.searchForm.dateRange ? this.searchForm.dateRange[1] : '',
        page: this.pagination.page,
        row: this.pagination.row
      }
      return params
    },
    async handleSearch() {
      this.pagination.page = 1
      this.summaryPagination.page = 1
      await this.fetchData()
    },
    handleReset() {
      this.searchForm = {
        communityIds: [],
        dateRange: []
      }
      this.isAllCommunitiesSelected = false
      this.summaryPagination = { page: 1, row: 20, total: 0 }
      this.pagination = { page: 1, row: 20, total: 0 }
      this.summaryData = []
      this.detailData = []
    },
    toggleSelectAllCommunities() {
      if (this.isAllCommunitiesSelected) {
        this.searchForm.communityIds = []
        this.isAllCommunitiesSelected = false
      } else {
        this.searchForm.communityIds = this.communityList.map(c => c.communityId)
        this.isAllCommunitiesSelected = true
      }
    },
    async fetchData() {
      try {
        this.loading = true
        if (this.activeTab === 'byCommunity') {
          const params = this.buildParams()
          params.page = this.summaryPagination.page
          params.row = this.summaryPagination.row
          const res = await queryReportCommunityFeeSummary(params)
          if (res.data && res.data.code === 0) {
            this.summaryData = res.data.data || []
            this.summaryPagination.total = res.data.total || 0
          }
        } else {
          const params = this.buildParams()
          params.page = this.pagination.page
          params.row = this.pagination.row
          const res = await queryReportCommunityFeeSummaryDetail(params)
          if (res.data && res.data.code === 0) {
            this.detailData = res.data.data || []
            this.pagination.total = res.data.total || 0
          }
        }
      } catch (error) {
        this.$message.error(this.$t('communityFeeSummary.multiCommunityFeeSummary.fetchError'))
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleTabClick() {
      this.summaryPagination.page = 1
      this.pagination.page = 1
      this.fetchData()
    },
    handleSummarySizeChange(val) {
      this.summaryPagination.row = val
      this.summaryPagination.page = 1
      this.fetchData()
    },
    handleSummaryCurrentChange(val) {
      this.summaryPagination.page = val
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pagination.row = val
      this.pagination.page = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchData()
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2)
    },
    formatRate(value) {
      return (Number(value || 0).toFixed(2)) + '%'
    },
    getRateColor(rate) {
      if ((rate || 0) >= 90) return '#67C23A'
      if ((rate || 0) >= 60) return '#E6A23C'
      return '#F56C6C'
    },
    async handleExport() {
      this.loading = true
      try {
        if (this.activeTab === 'byCommunity') {
          await this.exportSummaryData()
        } else {
          await this.exportDetailData()
        }
      } catch (error) {
        this.$message.error('导出失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async exportSummaryData() {
      // 请求全部数据（不分页）
      const params = this.buildParams()
      params.page = 1
      params.row = 99999
      const res = await queryReportCommunityFeeSummary(params)
      if (!res.data || res.data.code !== 0 || !res.data.data || res.data.data.length === 0) {
        this.$message.warning('没有数据可导出')
        return
      }
      const headers = [
        '小区名称', '总户数', '收费户数', '欠费户数',
        '历史欠费', '当期应收', '当期实收', '当期欠费', '总欠费', '实缴',
        '户收费率', '收费率', '清缴率'
      ]
      const data = res.data.data.map(row => [
        this.communityMap[row.communityId] || row.communityId,
        row.totalRoomCount || 0,
        row.feeRoomCount || 0,
        row.oweRoomCount || 0,
        this.formatMoney(row.hisOweFee),
        this.formatMoney(row.curReceivableFee),
        this.formatMoney(row.curReceivedFee),
        this.formatMoney(row.curOweFee),
        this.formatMoney(row.totalOweFee),
        this.formatMoney(row.actualPaid),
        this.formatRate(row.feeRoomRate),
        this.formatRate(row.feeRate),
        this.formatRate(row.clearRate)
      ])
      this.downloadExcel([headers, ...data], '按小区费用汇总')
    },
    async exportDetailData() {
      // 请求全部数据（不分页）
      const params = this.buildParams()
      params.page = 1
      params.row = 99999
      const res = await queryReportCommunityFeeSummaryDetail(params)
      if (!res.data || res.data.code !== 0 || !res.data.data || res.data.data.length === 0) {
        this.$message.warning('没有数据可导出')
        return
      }
      const headers = [
        '小区名称', '费用名称', '年份', '月份',
        '应收金额', '实收金额', '欠费金额'
      ]
      const data = res.data.data.map(row => [
        this.communityMap[row.communityId] || row.communityId,
        row.feeName,
        row.detailYear,
        row.detailMonth,
        this.formatMoney(row.receivableAmountTotal),
        this.formatMoney(row.receivedAmountTotal),
        this.formatMoney(row.oweAmountTotal)
      ])
      this.downloadExcel([headers, ...data], '费用明细汇总')
    },
    downloadExcel(data, fileName) {
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([wbout], { type: 'application/octet-stream' })
      saveAs(blob, fileName + '.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-community-fee-summary-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .w-100 {
    width: 100%;
  }

  .text-right {
    text-align: right;
  }

  .explain-icon {
    margin-right: 6px;
    color: #409EFF;
  }

  .community-select-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    .el-select {
      flex: 1;
    }

    .select-all-btn {
      position: absolute;
      right: 30px;
      z-index: 10;
      padding: 0;
      font-size: 12px;
    }
  }
}
</style>
